export const iconLinkVariants = {
  iconLink: {
    variant: 'text.body2',
    p: 3,
    color: 'onNavbar',
    display: 'flex',
    alignItems: 'center',
    transition: 'all .3s ease',
    '&:hover': {
      color: 'onNavbarHover',
      cursor: 'pointer',
    },
  },
  iconLinkLight: {
    variant: 'variants.iconLink',
    color: 'text',
    '&:hover': {
      cursor: 'pointer',
      color: 'onNavbar',
    },
  },
  iconLinkPrimary: {
    variant: 'variants.iconLink',
    color: 'primary',
    '&:hover': {
      cursor: 'pointer',
      color: 'primaryHover',
    },
  },
};
